<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import WhatsappTemplateRow from './WhatsappTemplateRow.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  inbox: { type: Object, required: true },
});
const { t } = useI18n();
const router = useRouter();
const store = useStore();

const isSyncing = ref(false);

const handleSyncTemplates = async () => {
  isSyncing.value = true;
  await store.dispatch('inboxes/syncWhatsappTemplates', {
    inboxId: props.inbox.id,
    successMessage: t('WHATSAPP_TEMPLATES.LIST.SYNC_SUCCESS'),
    errorMessage: t('WHATSAPP_TEMPLATES.LIST.SYNC_ERROR'),
  });
  isSyncing.value = false;
};

const tableHeaders = computed(() => [
  t('WHATSAPP_TEMPLATES.LIST.TABLE_HEADER.NAME'),
  t('WHATSAPP_TEMPLATES.LIST.TABLE_HEADER.STATUS'),
  t('WHATSAPP_TEMPLATES.LIST.TABLE_HEADER.CATEGORY'),
  t('WHATSAPP_TEMPLATES.LIST.TABLE_HEADER.LANGUAGE'),
  t('WHATSAPP_TEMPLATES.LIST.TABLE_HEADER.ACTIONS'),
]);
</script>

<template>
  <div class="m-8">
    <div class="flex justify-between mb-2 w-full">
      <div>
        <p class="text-2xl text-woot-500 dark:text-woot-500 font-medium mb-1">
          {{ $t('WHATSAPP_TEMPLATES.HEADER') }}
        </p>
        <p
          class="text-sm mb-2 text-slate-700 dark:text-slate-300 leading-5 tracking-normal mt-2"
        >
          {{ $t('WHATSAPP_TEMPLATES.DESCRIPTION') }}
        </p>
      </div>
      <div class="flex gap-2 items-center">
        <Button
          color="slate"
          :label="$t('WHATSAPP_TEMPLATES.LIST.SYNC_TEMPLATES')"
          :is-loading="isSyncing"
          @click="handleSyncTemplates"
        />
        <Button
          icon="i-lucide-plus"
          :label="$t('WHATSAPP_TEMPLATES.HEADER_BTN_TXT')"
          @click="
            router.push({
              name: 'create_whatsapp_templates',
              params: { inboxId: props.inbox.id },
            })
          "
        />
      </div>
    </div>

    <table class="min-w-full divide-y divide-slate-75 dark:divide-slate-700">
      <thead>
        <th
          v-for="header in tableHeaders"
          :key="header"
          class="py-4 pr-4 text-left font-semibold text-slate-700 dark:text-slate-300"
        >
          {{ header }}
        </th>
      </thead>
      <tbody
        class="divide-y divide-slate-50 dark:divide-slate-800 text-slate-700 dark:text-slate-300"
      >
        <WhatsappTemplateRow
          v-for="template in props.inbox.message_templates"
          :key="template.id"
          :template="template"
          @delete="() => {}"
        />
      </tbody>
    </table>
  </div>
</template>
